import React, { useCallback, useEffect, useState } from "react";
import { RiArrowLeftSLine } from "react-icons/ri";
import Footer from "../components/Footer";
import LoggedNav from "../components/LoggedNav";
import PopUp from "../components/Popup";
import Spinner from "./BePatient";
import Rating from '@mui/material/Rating';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { isMobile } from "react-device-detect";
import OwlCarousel from 'react-owl-carousel';
import { useNavigate } from "react-router-dom";
import profile from "../images/Vector.jpg";
import LinkPayment from './LinkPayment';
import DeletePaymentMethod from './DeletePaymentMethod';

function BrowseChef(props) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ single loader
  const [isPaymentLinked, setIsPaymentLinked] = useState(false); 
  const [shouldPollSyncStatus, setShouldPollSyncStatus] = useState(false);

  function extractValue(arr, prop) {
    return arr.map(item => item[prop]);
  }

  let navigate = useNavigate();

  const updateChefs = async () => {
    let data = await fetch(
      `${process.env.REACT_APP_BASE_URL}user/loggedin_chef_detail`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: localStorage.getItem("logged_user_id") || "",
          email: localStorage.getItem("owner") || ""
        }),
      }
    );
    let parsedData = await data.json();
    parsedData.data[0].chef_rating = 4.5; 
    parsedData.data[0].chef_total_number_of_reviews = 10; 
    setDetails(parsedData.data);
  };   

  // ✅ Payment status (no loader here)
  const checkPaymentStatus = useCallback(async () => {
    try {
      const user_id = localStorage.getItem("logged_user_id");
      const token = localStorage.getItem("token");

      const getAccountDetailsResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/get_chef_account_details`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id }),
        }
      );

      const getAccountDetailsData = await getAccountDetailsResponse.json();

      const normalizedEmailStatus = String(getAccountDetailsData.emailStatus || "")
        .replace(/[\s_]/g, "")
        .toUpperCase();

      if (
        getAccountDetailsData.status === true &&
        normalizedEmailStatus === "NOTCONFIRMED"
      ) {
        setShouldPollSyncStatus(true);
        setIsPaymentLinked(true);

        const syncPayPalStatusResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}user/syncChefPayPalStatus`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId: user_id }),
          }
        );

        const syncPayPalStatusData = await syncPayPalStatusResponse.json();

        if (
          syncPayPalStatusData.success &&
          syncPayPalStatusData.primary_email_confirmed === true &&
          syncPayPalStatusData.payments_receivable === true
        ) {
          setShouldPollSyncStatus(false);
          setIsPaymentLinked(true);
        } else {
          setShouldPollSyncStatus(true);
          setIsPaymentLinked(true);
        }
      } else if (
        getAccountDetailsData.status === true &&
        normalizedEmailStatus === "CONFIRMED"
      ) {
        setShouldPollSyncStatus(false);
        setIsPaymentLinked(true);
      } else {
        setShouldPollSyncStatus(false);
        setIsPaymentLinked(false);
      }
    } catch (err) {
      console.error("Error in checkPaymentStatus:", err);
      setIsPaymentLinked(false);
    }
  }, []);

  let role = localStorage.getItem("role");
  let token = localStorage.getItem("token");

  useEffect(() => {
    const title = "Profile | CHEF | CHEF REPUBLIC";
    const desc = "View Chef Profile in Detail including the menu, available timings, learn about the Chef, get to know the chef by viewing their pics";

    document.title = title;
    document.querySelector("meta[name='title']").setAttribute('content', title);
    document.querySelector("meta[name='description']").setAttribute('content', desc);
    document.querySelector("meta[property='og:title']").setAttribute('content', title);
    document.querySelector("meta[property='og:description']").setAttribute('content', desc);
    document.querySelector("meta[property='twitter:title']").setAttribute('content', title);
    document.querySelector("meta[property='twitter:description']").setAttribute('content', desc);

    if (role === null || role !== "2") {
      navigate("/chef/sign-in");
      window.location.reload();
    }
    if (token === null || !token) {
      navigate("/chef/sign-in");
      window.location.reload();
    }

    // ✅ Single loader for both APIs
    const initLoad = async () => {
      setLoading(true);
      await Promise.all([
        updateChefs(),
        checkPaymentStatus()
      ]);
      setLoading(false);
    };

    initLoad();

  }, [role, token, navigate, checkPaymentStatus]);

  useEffect(() => {
    if (!shouldPollSyncStatus) return;

    const intervalId = setInterval(() => {
      checkPaymentStatus();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [shouldPollSyncStatus, checkPaymentStatus]);

  function navigateEdit() {
    navigate("/chef/profile/edit");
  }

  function logout() {
    localStorage.clear();
    navigate("/chef");
  }

  const handlePaymentDeleted = () => {
    checkPaymentStatus();
    updateChefs();
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <LoggedNav customer={props.customer} />
          <div className="container mt-5 ">
            {!isMobile && (
              <nav aria-label="breadcrumb">
                <a href="/chef/order-list" style={{ textDecoration: "none", color: "black", fontWeight: 500 }}>
                  <RiArrowLeftSLine size={"2rem"} />
                  <span style={{ color: "#1e1e1e", fontWeight: 400 }}>Order List</span>
                </a>
              </nav>
            )}

            <div className="main_container row mt-4" style={{ display: "flex", flexDirection: isMobile ? "column" : "row" }}>
              
              {/* Sidebar */}
              <div className="col-4 vstack prof pe-4">
                <OwlCarousel items={1} center mouseDrag touchDrag autoplay autoplayHoverPause dotsEach className="owl-theme mb-4 shadow rounded-4 p-2" loop>
                  <div className="d-flex justify-content-center align-items-center">
                    <img alt="" className="image_box img-fluid" src={details[0].chef_profile_image} />
                  </div>
                </OwlCarousel>

                <button onClick={navigateEdit} className="btn btn-orange rounded-pill mb-3">Edit Profile</button>

                <LinkPayment
                  isPaymentLinked={isPaymentLinked}
                  onAddChefAccountSuccess={checkPaymentStatus}
                />

                <DeletePaymentMethod 
                  isPaymentLinked={isPaymentLinked} 
                  onPaymentDeleted={handlePaymentDeleted}
                />

                <button onClick={() => navigate("/chef/order-list")} className="btn btn-orange mb-3">Order List</button>
                <button onClick={logout} className="btn btn-orange mb-3">Logout</button>
              </div>

              {/* Main */}
              <div className="col-8 py-3">
                <h4>{details[0].chef_name}</h4>
                <h6>{details[0].chef_city}</h6>

                <Rating value={Number(details[0].chef_rating)} readOnly />

                <p>{details[0].chef_description}</p>
              </div>
            </div>
          </div>
          <Footer top={1} />
        </>
      )}
    </>
  );
}

export default BrowseChef;